module.exports = __webpack_public_path__ + "img/heart_rate.918ee0d1.png";